<template>
  <div v-cloak>
    <section class="small-12 medium-12 large-6 columns">
      <!-- /************* ADDITIONAL INFORMATIONS *************/ -->
      <h1 v-html="vueModel.ContentViewModel.Step4Shared.StepTitle" />

      <!-- /************* ATTACH FURTHER INFORMATION *************/ -->
      <article v-if="!hideUploadFile" id="step1">
        <h3 v-html="vueModel.ContentViewModel.Step4Shared.TitleAttachDocumentation" />

        <p v-html="vueModel.ContentViewModel.Step4Shared.TextAttachDocumentation" />

        <upload
          v-model="vueModel.files"
          :content="vueModel.ContentViewModel.Step4Shared"
          :title="vueModel.ContentViewModel.Step4Shared.UploadFileFormViewModel.FileListHeadline"
        />
      </article>

      <!-- /************* FIELDS TO ADD EXTRA CONTACT *************/ -->
      <add-contact-person
        :vue-model="vueModel"
        :step-model="stepModel"
        :model="vueModel.ContentViewModel.Step4Shared"
        :errors="errors"
      />

      <!-- /************* CONFIRM OR EDIT CONTACT INFORMATION *************/ -->
      <article id="step2">
        <h3 v-html="vueModel.ContentViewModel.Step4Shared.TitleContactInformation" />
        <p class="extra-margin-bottom" v-html="vueModel.ContentViewModel.Step4Shared.TextContactInformation" />
        <div class="control">
          <div class="row">
            <!-- /*** CONFIRM: PHONE ***/ -->
            <div class="small-12 medium-5 columns">
              <label
                for="phone"
                class="text-question"
                v-html="vueModel.ContentViewModel.Step4Shared.LabelAndTooltipContactInformationPhone"
              />
              <Field
                id="phone"
                v-model="vueModel.CreateClaimEntity.ClaimantTelephone"
                :rules="{ required: true, numeric: true, min: 8, max: 8 }"
                name="phone"
                type="tel"
                maxlength="8"
                :label="vueModel.ContentViewModel.Step4Shared.ErrorMessageContactInformationPhone"
                :disabled="saving"
                :[`aria-invalid`]="errors['phone'] ? true : false"
                :class="{ invalid: errors['phone'] }"
              />
              <ValidationError name="phone" />
            </div>
            <!-- /*** CONFIRM: EMAIL ***/ -->
            <div class="small-12 medium-7 columns">
              <label
                for="email"
                class="text-question"
                v-html="vueModel.ContentViewModel.Step4Shared.LabelAndTooltipContactInformationEmail"
              />
              <Field
                id="email"
                v-model="vueModel.CreateClaimEntity.ClaimantEmail"
                :rules="{ required: true, email: true }"
                name="email"
                type="email"
                :label="vueModel.ContentViewModel.Step4Shared.ErrorMessageContactInformationEmail"
                :[`aria-invalid`]="errors['email'] ? true : false"
                :disabled="saving"
                :class="{ invalid: errors['email'] }"
              />
              <ValidationError name="email" />
            </div>
          </div>
        </div>
      </article>

      <!-- /************* NEXT BUTTON *************/ -->
      <div id="step4" class="row">
        <div class="small-12 medium-6 columns">
          <a class="button large" data-test="send-claim" :disabled="saving === false ? undefined : true" @click="save">
            {{ vueModel.ContentViewModel.Step4Shared.ButtonTextSendClaim }}
            <div v-show="saving" class="spinner spinner-button" />
          </a>
        </div>
      </div>
      <!-- /************* GDPR PRIVACY INFORMATION *************/ -->
      <p>
        <a
          :href="vueModel.ContentViewModel.Step4Shared.LinkPersonalPrivacyURL"
          target="_blank"
          v-html="vueModel.ContentViewModel.Step4Shared.LinkPersonalPrivacyText"
        />
      </p>
      <!-- /************* HOW WE HANDLE CLAIMS INFORMATION *************/ -->
      <p>
        <a
          :href="vueModel.ContentViewModel.Step4Shared.LinkHowWeHandleClaimsURL"
          target="_blank"
          v-html="vueModel.ContentViewModel.Step4Shared.LinkHowWeHandleClaimsText"
        />
      </p>

      <!-- /************* BACK BUTTON *************/ -->
      <p class="section-content-top">
        <a data-test="create-claim-flow-back-button" @click="$parent.$parent.$parent.back">&lt; Tilbage</a>
      </p>
    </section>
    <!-- /************* ADD VIEWS TO MODAL INFORMATION *************/ -->

    <transition name="modal">
      <v-modal :is-open="showModal" modal-class="alt-modal" @close="redirect">
        <template #title>
          <h3>
            {{ modalTitle }}
          </h3>
        </template>
        <template #content>
          <div id="create-claim-confirmation-modal" v-html="modalContent" />
        </template>
        <template #footer>
          <div class="row medium-12 large-12">
            <div class="columns grid-x grid-padding-x align-center push-up">
              <button class="button text-center large-8 medium-8 small-10" @click="redirect">
                Gå til Min Side
              </button>
            </div>
          </div>
          <div
              v-if="showClaimOverviewLink"
              class="medium-12 large-12"
          >
            <a
              class="show-for-large grid-x grid-padding-x align-center text-color-primary"
              data-test-open-claim-overview-modal-link
              :href="claimOverviewLink + claimNumber"
            >
              Vis min anmeldelse
            </a>
          </div>
        </template>
      </v-modal>
    </transition>
  </div>
</template>

<script>
import AddContactPerson from '../../components/AddContactPerson.vue';
import { hasProperty } from '@/common/Util/utility.js';
import ValidationError from '@/components/UI/ValidationError.vue';
import Upload from '../../components/Upload.vue';
import Utility from '@/common/UtilityFunctions.js';
import ReportClaimMixin from '@/components/Feature/Claims/flows/ReportClaimMixin.vue';
import ReportClaimServicesMixin from '@/components/Feature/Claims/flows/ReportClaimServicesMixin.vue';

export default {
  name: 'ReportClaimSharedStep4',
  components: {
    AddContactPerson,
    Upload,
    ValidationError
  },
  mixins: [ReportClaimMixin, ReportClaimServicesMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    trackingVm: {
      type: Object,
      default() {
        return {};
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      showModal: false,
      modalTitle: 'test 1',
      modalContent: 'test 2',
      stepModel: this.vueModel.CreateClaimStep4Model,
      contentStepModel: this.vueModel.ContentViewModel.Step4Shared,
      createRequest: null,
      uploadRequest: null,
      claimResponse: null,
      appraiserReferenceResponse: null,
      createSuccessful: true,
      appraiserReferralSuccesful: true,
      uploadSuccesful: true,
      autoRedirectRouteParameter: '',
      hasAutoRedirect: false,
      claimNumber: ''
    };
  },
  computed: {
    validContact() {
      return this.vueModel.CreateClaimEntity.ClaimantTelephone !== '' && this.vueModel.CreateClaimEntity.ClaimantEmail !== ''
        ? true
        : false;
    },
    validExtraContact() {
      return this.vueModel.CreateClaimEntity.ClaimantExtraFirstName !== '' &&
        this.vueModel.CreateClaimEntity.ClaimantExtraLastName !== '' &&
        this.vueModel.CreateClaimEntity.ClaimantExtraTelephone.PhoneNumber !== '' &&
        this.vueModel.CreateClaimEntity.ClaimantExtraEmail.EmailAddress !== ''
        ? true
        : false;
    },
    hideUploadFile() {
      if (this.stepModel && this.stepModel.HideUploadFile) {
        return true;
      }

      return false;
    },
    claimOverviewLink() {
      return this.vueModel.ContentViewModel.Step4Shared.ClaimOverviewRelativeLink + '/';
    },
    showClaimOverviewLink() {
      return this.claimNumber.length > 0;
    }
  },
  watch: {
    'stepModel.AddExtraContact': function () {
      this.vueModel.CreateClaimEntity.ClaimantExtraFirstName = null;
      this.vueModel.CreateClaimEntity.ClaimantExtraLastName = null;
      this.vueModel.CreateClaimEntity.ClaimantExtraTelephone.PhoneNumber = null;
      this.vueModel.CreateClaimEntity.ClaimantExtraEmail.EmailAddress = null;

      if (this.stepModel.AddExtraContact) {
        this.$nextTick(() => {
          Utility.scrollToElem($('#AddExtraContact'));
        });
      }
    }
  },
  created() {
    function isValidDate(date) {
      return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
    }

    function traverse(obj) {
      for (var k in obj) {
        if (obj[k] && typeof obj[k] === 'object') {
          traverse(obj[k]);
        } else {
          // Do something with obj[k]

          if (isValidDate(k)) {
            // console.log(k, obj[k]);
          }
        }
      }
    }

    traverse(this.vueModel.CreateClaimEntity);

    // TODO: remove these manually added error messages to vueModel
    this.stepModel.ErrorMessages = {
      CouldNotConnectToClaimCreationEndpointTitle: 'Skaden kunne ikke gemmes',
      CouldNotConnectToClaimCreationEndpointContent:
        '<p>Vi kunne desværre ikke gemme din skade, kontakt os venligst telefonisk.</p>',
      ClaimSavedAppraiserReferralFailedUploadFailedTitle:
        'Din skade gemt, men vi kunne ikke gemme værksted eller uploadet fil',
      ClaimSavedAppraiserReferralFailedUploadFailedContent:
        '<p>Kontakt os venligst telefonisk.</p><p>Skadenummer: [ClaimNumber]</p>',
      ClaimSavedUploadFailedTitle: 'Din skade er gemt, men vi kunne ikke uploade fil',
      ClaimSavedUploadFailedContent:
        '<p>Kontakt os venligst telefonisk.</p><p>Skadenummer: <strong>[ClaimNumber]</strong></p>'
    };
  },
  methods: {
    toggleModal(title, content) {
      this.modalTitle = title;
      this.modalContent = content;
      this.saving = false;
      this.showModal = true;
    },
    async save() {
      var vm = this;

      if (vm.saving) {
        return;
      }

      if (
        vm.vueModel.CreateClaimStep1Model.SelectedAddressType === 3 &&
        vm.vueModel.CreateClaimStep1Model.ShortPlaceOfDamageDescription
      ) {
        vm.vueModel.CreateClaimEntity.EventLocation.City = '.';
      }

      const result = await this.$parent.$parent.validate();

      if (!result.valid) {
        return this.scrollToFirstError();
      }

      vm.saving = true;

      this.$emit('stop-timer', true);

      this.createRequest = Utility.post(
        Utility.constants().API.createclaim_create,
        vm.vueModel.CreateClaimEntity,
        this.createClaimSuccess,
        this.createClaimFail,
        vm
      );
    },
    redirect() {
      window.location = this.contentStepModel.LinkToPageAfterConfirmationMessage;
    },
    error() {
      window.location = this.contentStepModel.LinkToPageAfterErrorMessage;
    },
    autoRedirect() {
      this.saving = false;
      window.location.replace(this.claimOverviewLink + this.autoRedirectRouteParameter);
    },
    setAutoRedirectRouteParameter(param) {
      this.autoRedirectRouteParameter = param;
    },
    createClaimSuccess(response) {
      this.claimResponse = response.data.ResponseResultList.find(
        (obj) => obj.AreaType === 'CreateClaim_CreateClaim' || obj.AreaType === 'CreateClaim_CreateClaimException'
      );

      this.appraiserReferenceResponse = response.data.ResponseResultList.find(
        (obj) => obj.AreaType === 'CreateClaim_SendAppraiserReference'
      );

      // if claim creation fails, show error message and break
      if (!this.claimResponse || !this.claimResponse.IsSuccess) {
        this.createSuccessful = false;
      }

      this.createSuccessful ? this.dispatchEventWithApiSuccess(this.trackingVm) : this.dispatchEventWithApiFailure(this.trackingVm);

      if (this.appraiserReferenceResponse !== undefined && !this.appraiserReferenceResponse.IsSuccess) {
        this.appraiserReferralSuccesful = false;
      }

      // if any files have been selected, proceed with upload
      if (this.vueModel.files.length > 0 && this.createSuccessful) {
        // construct FormData object
        const damageCodesJSON = JSON.stringify(this.vueModel.CreateClaimEntity.DamageCodes);
        const formData = new FormData();

        for (var a = 0; a < this.vueModel.files.length; a++) {
          formData.append('files[' + a + ']', this.vueModel.files[a]);
        }

        formData.append('CreatedClaimId', this.claimResponse.Data.CreatedClaimNumber);
        formData.append('DamageCodes', damageCodesJSON);

        this.uploadRequest = Utility.post(
          Utility.constants().API.createclaim_upload,
          formData,
          this.uploadSuccess,
          this.uploadFail,
          this
        );
      }

      if (
        this.claimResponse &&
        this.claimResponse.IsSuccess &&
        this.claimResponse.RedirectModel &&
        this.claimResponse.RedirectModel.HasRedirect
      ) {
        this.hasAutoRedirect = true;
        this.setAutoRedirectRouteParameter(this.claimResponse.RedirectModel.Parameter);
      }

      Utility.all([this.createRequest, this.uploadRequest], this.allSuccess, this.allFail, this);
    },
    createClaimFail(error) {
      Utility.logError(error, this);

      return this.toggleModal(
        this.stepModel.ErrorMessages.CouldNotConnectToClaimCreationEndpointTitle,
        this.stepModel.ErrorMessages.CouldNotConnectToClaimCreationEndpointContent
      );
    },
    uploadSuccess(response) {
      if (!hasProperty(response.data, 'IsSuccess') || !response.data.IsSuccess) {
        this.uploadSuccesful = false;
      }
    },
    uploadFail(error) {
      this.uploadSuccesful = false;
      Utility.logError(error, this);
    },
    allSuccess() {
      if (this.createSuccessful) {
        const claimNumber =
          this.claimResponse.Data.CreatedClaimNumber !== null
            ? this.claimResponse.Data.CreatedClaimNumber
            : this.claimResponse.Data.CreatedClaimId;

        let modalTitle = '';
        let modalContent = '';

        if (!this.appraiserReferralSuccesful && !this.uploadSuccesful) {
          modalTitle = this.stepModel.ErrorMessages.ClaimSavedAppraiserReferralFailedUploadFailedTitle;
          modalContent = this.stepModel.ErrorMessages.ClaimSavedAppraiserReferralFailedUploadFailedContent;
        } else if (!this.appraiserReferralSuccesful) {
          // claim saved, but there was an issue with appraiser referral
          modalTitle = this.appraiserReferenceResponse.FrontEndTitleMessage;
          modalContent = this.appraiserReferenceResponse.FrontEndContentMessage;
        } else if (!this.uploadSuccesful) {
          modalTitle = this.stepModel.ErrorMessages.ClaimSavedUploadFailedTitle;
          modalContent = this.stepModel.ErrorMessages.ClaimSavedUploadFailedContent;
        } else {
          // all requests are now complete without any problems
          modalTitle = this.claimResponse.FrontEndTitleMessage;
          modalContent = this.claimResponse.FrontEndContentMessage;
        }

        const modalContentReplaced = Utility.stringTokenReplace(
          modalContent,
          '[ClaimNumber]',
          '<a href="' + this.claimOverviewLink + claimNumber + '">' + claimNumber + '</a>'
        );
        if (this.hasAutoRedirect) {
          return this.autoRedirect();
        }
        this.claimNumber = claimNumber;
        return this.toggleModal(modalTitle, modalContentReplaced);
      }

      if (this.hasAutoRedirect) {
        return this.autoRedirect();
      }

      return this.toggleModal(this.claimResponse.FrontEndTitleMessage, this.claimResponse.FrontEndContentMessage);
    },
    allFail() {
      return null;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.extra-margin-bottom {
  margin-bottom: rem-calc(30px);
}
</style>
